

import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { WorkExperiencesFormComponent } from './work-experiences-form/work-experiences-form.component';
import { AmbassadorWorkExperience } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/models/AmbassadorWorkExperience';
import { AmbassadorsProfileService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/ambassadors-profile.service';
import { ConnectLookupsService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/connectLookups.service';
@Component({
  selector: 'app-work-experiences',
  standalone: false,
  templateUrl: './work-experiences.component.html'
})
export class WorkExperiencesComponent implements OnInit {
  @Input() canModify!: boolean;
  @Input() userId!: any;
  formGroup!: FormGroup;
  showModal = false
  dataLoading = false
  dataSource: AmbassadorWorkExperience[] = []

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private service: AmbassadorsProfileService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getAll()
  }


  getAll() {
    this.dataLoading = true;
    const params = this.userId ? { userId: this.userId } : {};
    this.service.GetAmbassadorWorkExperience(params).subscribe((response: any) => {
      this.dataLoading = false;
      this.dataSource = response as AmbassadorWorkExperience[];
    }, (err: any) => {
      this.dataLoading = false
    })
  }

  openForm(record: any = null) {
    const dialogRef = this.dialog.open(WorkExperiencesFormComponent, {
      width: '550px',
      data: { record },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAll();
      }
    });

  }





  deleteRecord(id: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.service.DeleteAmbassadorWorkExperience(id).subscribe(
          (data: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.deletededsuccessfuly'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            });
            this.getAll();
          }, (error: any) => {
            console.error(error);
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: this.translate.instant('swalMsg.FailedText'),
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            });
          });
      }
    });
  }


}

